"use strict";
/**
 * RANGE FISIOLOGICI NORMATIVI + DEFAULT RECOVERY — fonte unica (@leopart/calc).
 *
 * Le tabelle CMJ/FCR/HRV sono NORME di dominio (per genere × fascia d'età), non
 * config per-team: erano hardcoded in
 * apps/backend/src/services/recovery/recovery.constants.ts. `DEFAULT_RECOVERY_CONFIG`
 * è il default applicato quando un team non ha una sua config: i valori sono
 * scelte di dominio (pesi dei fattori, soglie complaint), quindi stanno qui;
 * l'OVERRIDE per-team resta un dato in DB, non una costante.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RECOVERY_CONFIG = exports.HRV_RANGES = exports.FCR_RANGES = exports.CMJ_RANGES = void 0;
exports.getAgeGroup = getAgeGroup;
const constants_1 = require("./constants");
/** ≥18 anni → adulto, altrimenti u18 (soglia di dominio dei range normativi). */
function getAgeGroup(age) {
    return age >= 18 ? 'adult' : 'u18';
}
exports.CMJ_RANGES = {
    male: {
        adult: {
            ottima: { min: 45, max: Infinity },
            buona: { min: 35, max: 44 },
            media: { min: 25, max: 34 },
            bassa: { min: -Infinity, max: 24 },
        },
        u18: {
            ottima: { min: 40, max: Infinity },
            buona: { min: 30, max: 39 },
            media: { min: 20, max: 29 },
            bassa: { min: -Infinity, max: 19 },
        },
    },
    female: {
        adult: {
            ottima: { min: 38, max: Infinity },
            buona: { min: 28, max: 37 },
            media: { min: 18, max: 27 },
            bassa: { min: -Infinity, max: 17 },
        },
        u18: {
            ottima: { min: 35, max: Infinity },
            buona: { min: 25, max: 34 },
            media: { min: 15, max: 24 },
            bassa: { min: -Infinity, max: 14 },
        },
    },
};
exports.FCR_RANGES = {
    male: {
        adult: {
            ottima: { min: -Infinity, max: 48 },
            buona: { min: 49, max: 56 },
            media: { min: 57, max: 64 },
            bassa: { min: 65, max: Infinity },
        },
        u18: {
            ottima: { min: -Infinity, max: 52 },
            buona: { min: 53, max: 60 },
            media: { min: 61, max: 68 },
            bassa: { min: 69, max: Infinity },
        },
    },
    female: {
        adult: {
            ottima: { min: -Infinity, max: 52 },
            buona: { min: 53, max: 60 },
            media: { min: 61, max: 68 },
            bassa: { min: 69, max: Infinity },
        },
        u18: {
            ottima: { min: -Infinity, max: 56 },
            buona: { min: 57, max: 64 },
            media: { min: 65, max: 72 },
            bassa: { min: 73, max: Infinity },
        },
    },
};
exports.HRV_RANGES = {
    male: {
        adult: {
            ottima: { min: 4.4, max: Infinity },
            buona: { min: 4.0, max: 4.39 },
            media: { min: 3.6, max: 3.99 },
            bassa: { min: -Infinity, max: 3.59 },
        },
        u18: {
            ottima: { min: 4.25, max: Infinity },
            buona: { min: 3.85, max: 4.24 },
            media: { min: 3.45, max: 3.84 },
            bassa: { min: -Infinity, max: 3.44 },
        },
    },
    female: {
        adult: {
            ottima: { min: 4.3, max: Infinity },
            buona: { min: 3.9, max: 4.29 },
            media: { min: 3.5, max: 3.89 },
            bassa: { min: -Infinity, max: 3.49 },
        },
        u18: {
            ottima: { min: 4.25, max: Infinity },
            buona: { min: 3.85, max: 4.24 },
            media: { min: 3.45, max: 3.84 },
            bassa: { min: -Infinity, max: 3.44 },
        },
    },
};
/**
 * Config recovery applicata quando un team non ne ha una propria.
 * Pesi dei 4 fattori + soglie: scelte di dominio (l'override per-team vive in DB).
 */
exports.DEFAULT_RECOVERY_CONFIG = {
    weights: { cmj: 25, fcr: 22.5, hrv: 25, hooper: 27.5 },
    notificationHour: '07:00',
    readinessToTrainEnabled: false,
    sleepHoursEnabled: true,
    bodyMapEnabled: true,
    riAlertThreshold: constants_1.RI_THRESHOLDS.warning,
    riWarningThreshold: constants_1.RI_THRESHOLDS.normal,
    persistentComplaintDays: 3,
    complaintIntensityAlert: 4,
    athleteRiVisible: false,
};
